import Swal from 'sweetalert2'

export function showHttpErrorAlert (error: any): void {
  if (error.response) {
    Swal.fire({
      icon: 'error',
      title: error.response.data.message
    })
  } else if (error.request) {
    Swal.fire({
      icon: 'error',
      title: 'Cannot connect to server'
    })
  } else {
    console.error(error)
    Swal.fire({
      icon: 'error',
      title: 'Please try again'
    })
  }
}
